import CarManagement from './CarManagement.vue'
export default CarManagement



// WEBPACK FOOTER //
// ./src/pages/CarManagement/index.js